export default __webpack_public_path__ + "static/h1company-11bdf83b6251a9974b901ad4afbdae0c.png";